var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21 12.4412C21 17.4117 16.9706 21.4412 12 21.4412M21 12.4412C21 7.4706 16.9706 3.44116 12 3.44116M21 12.4412C21 14.098 16.9706 15.4412 12 15.4412C7.02944 15.4412 3 14.098 3 12.4412M21 12.4412C21 10.7843 16.9706 9.44116 12 9.44116C7.02944 9.44116 3 10.7843 3 12.4412M12 21.4412C7.02944 21.4412 3 17.4117 3 12.4412M12 21.4412C10.3431 21.4412 9 17.4117 9 12.4412C9 7.4706 10.3431 3.44116 12 3.44116M12 21.4412C13.6569 21.4412 15 17.4117 15 12.4412C15 7.4706 13.6569 3.44116 12 3.44116M3 12.4412C3 7.4706 7.02944 3.44116 12 3.44116",
    stroke: "white",
    strokeWidth: 1.93802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ebdead1c20a6c51fd1716dd027587b63.svg";
export { ForwardRef as ReactComponent };